/* eslint-disable no-use-before-define */
import React from "react";
import TextField from '@mui/material/TextField';
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";

const filter = createFilterOptions();

const TagsAutoComplete = ({ addTags, existedTags }) => {
  return (
    <Autocomplete
      multiple
      id="tags-standard"
      options={existedTags}
      onChange={(event, newValue) => {
        addTags(newValue);
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        const filteredNames = filtered.map((tag) => tag.name);
        // Suggest the creation of a new value
        if (
          params.inputValue !== "" &&
          // don't show "add new tag" if the tag name exists
          !filteredNames.includes(params.inputValue)
        ) {
          filtered.push({
            inputValue: params.inputValue,
            name: params.inputValue,
            title: `Add "${params.inputValue}"`,
          });
        }

        return filtered;
      }}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === "string") {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.title;
      }}
      renderOption={(option) => option.title}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="categories"
          placeholder="category"
        />
      )}
    />
  );
};

export default TagsAutoComplete;
